import { render } from "../../templates/partner-cart-technology-park.html?vue&type=template&id=ec5cd7b2&scoped=true"
import script from "./technology-park.vue?vue&type=script&lang=js"
export * from "./technology-park.vue?vue&type=script&lang=js"

import "./technology-park.vue?vue&type=style&index=0&id=ec5cd7b2&scoped=true&lang=scss"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec5cd7b2"]])

export default __exports__